<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre2">
<br class="calibre10" id="calibre_pb_1"/> </p>
<p class="calibre11"> <a class="calibre5" id="_Toc29478517"><span class="calibre12"> </span></a> </p>
<p class="calibre11"> <span class="calibre12"> </span> </p>
<p class="calibre11"> <span class="calibre12"> </span> </p>
<p class="calibre11"> <span class="calibre12"> </span> </p>
<p class="calibre11"> <span class="calibre12">The Blue Rose</span><span class="calibre3">…signifying hope against unattainable love…longing to attain the impossible.</span><span class="calibre13"></span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre14"> <span class="calibre3">—A Chinese Folktale</span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3">“The General who advances without coveting fame and retreats without fearing disgrace, whose only thought is to protect his country and do good service for his sovereign, is the…</span><span class="calibre12">Jewel of the Kingdom</span><span class="calibre3">.” </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre14"> <span class="calibre3">—Sun Tzu </span> </p>
<p class="calibre15"> <span class="calibre16" id="calibre_pb_2"></span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_001.vue?376a93f8